<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Vacancy content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">

        <div class="field-sec">
          <label>Search placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.placeholder" />
        </div>
        <div class="field-sec">
          <label>More about text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.more_about" />
        </div>

      </form>

      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <div class="machine-container">
        <div>
          <h1 class="">{{ fit20.selectTabId }} Vacancy's data</h1>
          <br>
          <div class="search-add-sec">
            <input type="text" placeholder="Search..." @input="filterVacancy" />
            <img width="50" @click.stop.prevent="showAddVacancy()"
              src="https://storage.googleapis.com/fit20app-4-acctest.appspot.com/static/icons/%2B.png" />
          </div>
        </div>

        <!-- <input type="text" placeholder="Search..." @input="filterStudios" /> -->
        <div class="machines" v-if="filteredVacancy.length > 0">
          <div :class="['studios-card', { inactive: !vacancy.active }]" v-for="vacancy in filteredVacancy"
            :key="vacancy.link" @click.stop.prevent="getVacancy(vacancy.link)">
            <a href="#" :id="vacancy.link">
              <div>{{ vacancy.main_title }}</div>
            </a>
          </div>
        </div>
        <!-- start edit member popup  -->
        <div class="popup-overlay" v-if="vacancyToEdit">
          <div class="edit-member">
            <div class='popup-title flex'>
              <span>{{ vacancy.main_title }}</span>
              <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="getVacancy(false)" />
            </div>
            <div class="flex edit-member-body">
              <form class="session-form-container" id="admin_studio_info">
                <div class="flex edit-member-1sec">
                  <div class="field-sec">
                    <label>Date:</label>
                    <input type="date" class="form-control" v-model="formattedDate" />
                  </div>
                  <div class="field-sec">
                    <label>Main title*:</label>
                    <input type="text" class="form-control" v-model="vacancyToEdit.main_title" />
                  </div>
                  <div class="field-sec">
                    <label>Sub title:</label>
                    <input type="text" class="form-control" v-model="vacancyToEdit.sub_title" />
                  </div>
                  <div class="field-sec">
                    <label>Link to the page*:</label>
                    <input type="text" class="form-control" v-model="vacancyToEdit.link" />
                  </div>
                  <div class="field-sec">
                    <label>Image file location and Image name with format:</label>
                    <input type="text" class="form-control" v-model="vacancyToEdit.img_link" />
                  </div>
                  <div class="field-sec">
                    <label>Small text for Vacancy page:</label>
                    <textarea type="text" class="form-control" v-model="vacancyToEdit.small_text"></textarea>
                  </div>
                  <div class="field-sec">
                    <label>Tags:</label>
                    <textarea type="text" class="form-control" v-model="vacancyToEdit.tags"></textarea>
                  </div>


                  <div class="field-sec">
                    <label>Active:</label>
                    <select id="" class="" v-model="vacancyToEdit.active">
                      <option :value=false>NO</option>
                      <option :value=true>YES</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div>
              <div class="fake-div"></div>
              <div class="btn-container">
                <span :class="'fit20-btn ' + (isChanged ? 'save-btn-active' : 'save-btn-disable')"
                  @click="saveVacancy(newVacancy);">
                  Save
                </span>
              </div>
            </div>
            <br>
          </div>
        </div>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div id="fit20_news_sec" class="news-container">
        <div class="title-search-sec">
          <h2 id="news_title"></h2>
          <div id="search_sec">
            <div class="news-search-filter-field-box">
              <div class="news-search-field-box">
                <input id="news_search" class="news-search-field" type="search"
                  :placeholder="fit20.blockToEdit.placeholder" />
                <i class="fa fa-fw fa-search" onclick="" style="font-size: 20px"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="news-sec" id="news_sec">
          <a href="#" class="">
            <div class="one-news">
              <div class="news-img-div">
                <img loading="lazy" src="https://www.fit20.com/files/images/Global/Global Photoshoot/Fit20-1004.jpg"
                  alt="" />
              </div>
              <div class="news-text-cec">
                <div class="news-title-sec-div">
                  <div class="news-header-sec">
                    <h2 class="news-title">Test1 test1</h2>
                  </div>
                </div>
                <div class="news-text">Test1 test1 Test1 test1 Test1 test1 Test1 test1</div>
                <div class="news-link">
                  <a href="#" class="news-read-more">{{ fit20.blockToEdit.more_about }} test1 Test1 test1... <i
                      class="fa fa-chevron-right" aria-hidden="true"></i></a>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="pagenation-sec">
          <nav class="pagination-container">
            <button class="pagination-button" id="prev-button" aria-label="Previous page" title="Previous page">
              &lt;
            </button>

            <div id="pagination-numbers"></div>

            <button class="pagination-button" id="next-button" aria-label="Next page" title="Next page">
              &gt;
            </button>
          </nav>
        </div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
export default {
  name: 'Vacancy',
  props: ["fit20", "saveBlock", "cancelEditing"],
  data() {
    return {
      newVacancy: false,
      vacancy: [],
      filteredVacancy: [],
      inputValue: '',
      vacancyToEdit: null,
      isChanged: false,
      originalVacancy: [],
    };
  },
  computed: {
    formattedDate: {
      get() {
        if (!this.vacancyToEdit.date) return ''; // fallback if not defined
        const d = new Date(this.vacancyToEdit.date);
        const year = d.getFullYear();
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      set(value) {
        this.vacancyToEdit.date = value ? new Date(value) : null;
      }
    },
  },
  methods: {

    showAddVacancy() {
      this.newVacancy = true;
      this.vacancyToEdit = {
        date: '',
        main_title: '',
        sub_title: '',
        link: '',
        img_link: '',
        active: true,
        small_text: '',
        tags: '',
      };
    },
    getVacancy(link) {
      this.newVacancy = false;
      if (link) {
        let vacancyToEdit = this.fit20.blockToEdit.vacancy.find(vacancy => vacancy.link == link);
        if (vacancyToEdit) {
          console.log(vacancyToEdit);
          this.vacancyToEdit = vacancyToEdit;
        } else {
          this.vacancyToEdit = null;
        }
      } else {
        this.vacancyToEdit = null;
        console.log(this.originalVacancy);
        this.fit20.blockToEdit.vacancy = JSON.parse(JSON.stringify(this.originalVacancy));
      }
    },
    saveVacancy(newVacancy) {
      //console.log(this.fit20.studios);

      if (isEqual(this.fit20.blockToEdit, this.originalVacancy) && !newVacancy) {
        alert('No changes to save');
        this.vacancyToEdit = null;
      } else if (!this.vacancyToEdit.link) {
        alert('Link to the page is required');
      }
      else if (!this.vacancyToEdit.main_title) {
        alert('main title is required');
      }
      else {
        if (newVacancy) {
          this.fit20.blockToEdit.vacancy.push(this.vacancyToEdit);
        }
        this.originalVacancy = JSON.parse(JSON.stringify(this.fit20.blockToEdit.vacancy));
        this.vacancyToEdit = null;
      }
      this.newVacancy = false;
    },
    filterVacancy(event) {
      this.inputValue = event;
      let searchWord = event.target.value.toLowerCase().trim()
      if (searchWord.length > 0) {
        this.filteredVacancy =
          this.fit20.blockToEdit.vacancy.filter(vacancy => vacancy.main_title.toLowerCase().includes(searchWord) || vacancy.small_text.toLowerCase().includes(searchWord));
      } else {
        this.filteredVacancy = [...this.fit20.blockToEdit.vacancy]
      }
    },
  },
  watch: {
    'fit20.blockToEdit.vacancy': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        // console.log("machines watch");
        if (!this.inputValue) {
          this.filteredVacancy = [...newVal];
          console.log("watcher >>>>>>>>>>>>>>>>");
        }
        if (this.originalVacancy.length < 1) {
          this.originalVacancy = JSON.parse(JSON.stringify(newVal));
          console.log("watcher2 >>>>>>>>>>>>>>>>");
        }
      }
    }
  }


};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */
.news-container {
  padding-top: 30px !important;
}

.news-sec {
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  align-items: center !important;
}

.news-search-field {
  width: 80% !important;
  border: none !important;
  padding: 5px 0 5px 5px !important;
  background-color: transparent !important;
  color: #494b53 !important;
  outline: none !important;
  border-radius: 30px !important;
  background-color: white !important;
}

#search_sec {
  text-align: center !important;
  margin-bottom: 20px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.news-search-filter-field-box {
  width: 20% !important;
  display: inline !important;
}

.news-search-field-box {
  background-color: #ffffff !important;
  /* width: 20% !important; */
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  border: solid 1px #494b5326 !important;
  border-radius: 30px !important;
  height: 30px !important;
}

.news-search-field-box input {
  border-radius: 30px !important;
  height: 25px !important;
  font-size: 12px !important;
}

#search_sec i {
  color: #009df4 !important;
  padding-right: 10px !important;
  cursor: pointer !important;
}

#search_sec span {
  margin-left: 10px !important;
  border: solid 1px #494b5350 !important;
  border-radius: 15px !important;
  padding: 1px 10px !important;
  color: #494b537e !important;
  cursor: pointer !important;
}

#search_sec span.active {
  background-color: #494b537e !important;
  color: white !important;
}

.one-news {
  max-width: 1500px !important;
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-bottom: 20px !important;
  padding-left: 10px !important;
  cursor: pointer;
}

.news-img-div {
  display: contents;
  width: 25% !important;
  min-width: 200px !important;
  min-height: 150px !important;
}

.news-img-div img {
  width: 250px !important;
  /* max-width: 350px !important; */
  max-height: 300px !important;
  /* min-width: 200px !important;
    min-height: 150px !important; */
  border-radius: 10px !important;
}

.news-text-cec {
  width: 75% !important;
  max-width: 700px !important;
  padding-left: 40px !important;
  margin: auto 0 !important;
}

.news-header-sec {
  width: 80% !important;
}

.news-header-sec h2 {
  width: 95% !important;
  font-family: 'VAG Rounded Std light light', Verdana, Tahoma, sans-serif !important;
  font-size: 22px !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

.news-header-sec div {
  font-size: 15px !important;
}

.news-tags {
  width: 20% !important;
  font-size: 15px !important;
}

.news-title-sec-div {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}

.news-text {
  width: 90% !important;
  font-size: 15px !important;
}

.news-link {
  width: 90% !important;
  font-size: 15px !important;
}

.one-news a:link,
.one-news a:active,
.one-news a:visited {
  color: #000000 !important;
  text-decoration: none !important;
}

.one-news .news-link a:link,
.one-news .news-link a:active,
.one-news .news-link a:visited {
  color: #009df4 !important;
  text-decoration: none !important;
}

.news-read-more {
  display: inline-block;
  width: 90%;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  overflow: hidden !important;
}

.fa-chevron-right:before {
  position: relative !important;
  bottom: -3px !important;
}

/* start Pagination style ..........................*/
.hidden {
  display: none !important;
}

.pagination-container {
  width: calc(100% - 2rem) !important;
  display: flex !important;
  align-items: center !important;
  /* position: absolute; */
  bottom: 0 !important;
  padding: 1rem 0 !important;
  justify-content: center !important;
}

.pagination-number,
.pagination-button {
  font-size: 1.1rem !important;
  background-color: transparent !important;
  border: none !important;
  margin: 0.25rem 0.25rem !important;
  cursor: pointer !important;
  height: 2.5rem !important;
  width: 2.5rem !important;
  border-radius: 0.2rem !important;
  color: #494b53 !important;
}

.pagination-number:hover,
.pagination-button:not(.disabled):hover {
  background: #fff !important;
}

.pagination-number.active,
.pagination-button.active {
  color: #92d400 !important;
  /* background: #0085b6; */
}

.display-none {
  display: none !important;
}

.spinner-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  /* Adjust this value if needed */
  z-index: 99999;
  background-color: transparent;
}

.spinner {
  width: 200px;
  display: inline-block;
  animation: spin 2.2s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* img {
    width: 200px;
  } */
/* start control the display of page number */
/* .pagination {
  display: flex;
  justify-content: center;
} */

/* .pagination-list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
  } */

/* .pagination-item {
    padding: 5px 10px;
    margin-right: 5px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 3px;
    cursor: pointer;
  }

  .pagination-item:hover {
    background-color: #ddd;
  }

  .pagination-item.pagination-number.active {
    background-color: #555;
    color: #fff;
  }

  .pagination-item.pagination-prev,
  .pagination-item.pagination-next {
    font-weight: bold;
  } */

/* .pagination-item.pagination-prev.disabled,
  .pagination-item.pagination-next.disabled {
    color: #ddd;
    cursor: default;
  } */

/* .pagination-item.pagination-prev:hover:not(.disabled),
  .pagination-item.pagination-next:hover:not(.disabled) {
    background-color: #ddd;
  } */
/* End Pagination style ..........................*/
@media only screen and (max-width: 900px) {
  .news-header-sec h2 {
    font-size: 17px !important;
  }

  .address-container {
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }
}

@media only screen and (max-width: 750px) {
  .news-text-cec {
    padding-left: 5px !important;
    text-align: center;
    width: 90% !important;
  }

  .news-header-sec {
    width: 100% !important;
  }

  .one-news {
    flex-wrap: wrap;
  }

  .news-img-div {
    display: flex;
    width: 100% !important;
    min-width: 125px !important;
    min-height: 100px !important;
  }

  .news-img-div img {
    min-width: 125px !important;
    /* min-height: 100px !important; */
    border-radius: 5px !important;
  }

  .news-search-filter-field-box {
    width: 80% !important;
  }
}

.machine-container {
  /* position: absolute;
  top: 0;
  left: 0; */
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}

.search-add-sec {
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
}

.search-add-sec img {
  width: 50px;
}

.machine-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 40%;
}

.machines {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 100px);
  /* Adjust as needed */
  overflow: auto;
  margin-top: 10px;
}

.studios-card {
  display: flex;
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 3 - 20px);
  /* min-height: 40px; */
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
}

.studios-card-inactive {
  background-color: var(--fit20-lighter-gray);
}

.selected {
  background-color: var(--fit20-blue);
  color: white !important;
  text-align: center;
  transition: all .8s;
}

.selected a {
  color: white !important;
}

.machine-card a {
  display: inline-block;
  width: 100%;
  height: 100%;
  /* margin-left: 10px; */
}

/* img {
  width: 35%;
  max-width: 110px;
  min-width: 70px;
  min-height: 70px;
} */
.edit-member {
  background-color: white;
  border-radius: 10px;
  width: 80%;
}

.edit-member-body {
  margin-top: 5px;
  padding-bottom: 10px;
}

.edit-member-body>form {
  width: 100%;
  padding-left: 10px;
}

.edit-member-1sec>.field-sec {
  width: 50%;
}

.field-sec {
  margin-top: 15px;
}

.field-sec.flex>label {
  padding: 0px 0px 0px 10px;
  /* margin-left: 10px; */
}

.member-info.flex {
  flex-wrap: nowrap;
}

.session-form-container input,
.session-form-container select,
.session-form-container textarea {
  width: 95%;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.session-form-container input,
.session-form-container select {
  height: 30px;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.field-sec.flex>label {
  width: 48%;
}

.field-sec.flex>input {
  width: fit-content;
}

.session-studio-container input.height {
  width: 60px !important;
  text-align: center;
}

.session-studio-container .fake-div {
  height: 88%;
}

.session-studio-container .close-popup {
  width: 30px;
  padding: 5px;
}
</style>
